import styled from "@emotion/styled";

export const Spacer = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
`;

export const HorizontalSpacer = () => <Spacer width="50px" />;
